var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    d: "M10.695 7.659c0-1.699 0-1.487.33-2.136a3.043 3.043 0 0 1 1.326-1.325c.65-.33 1.5-.33 3.198-.33h6.977c1.699 0 2.547 0 3.196.33a3.03 3.03 0 0 1 1.327 1.325c.33.648.33 1.497.33 3.193v14.57c0 1.696 0 2.544-.33 3.192a3.037 3.037 0 0 1-1.327 1.327c-.648.33-1.496.33-3.192.33h-6.986c-1.695 0-2.545 0-3.193-.33a3.035 3.035 0 0 1-1.325-1.327c-.33-.649-.33-.436-.33-2.135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "m15.477 12.977 3.217 3.217m.009.001-3.217 3.218"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M4.625 16.25h12.117"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.36d72f09c774904efdc6390396d8302a.svg";
export { ForwardRef as ReactComponent };